import { render, staticRenderFns } from "./buyerAddPrice.vue?vue&type=template&id=24349f3d&scoped=true"
import script from "./buyerAddPrice.vue?vue&type=script&lang=js"
export * from "./buyerAddPrice.vue?vue&type=script&lang=js"
import style0 from "./buyerAddPrice.vue?vue&type=style&index=0&id=24349f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24349f3d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderPayDialog: require('/drone/src/components/OrderPayDialog/index.vue').default})
